import React, { useEffect, useState } from 'react';
import { isClient } from '../../../utils';

export default (WrappedComponent) => {
  return (props) => {
    const [size, setSize] = useState([0, 0]);

    useEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      if (isClient()) {
        window.addEventListener('resize', updateSize);
        updateSize();
      }
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return <WrappedComponent {...props} windowSize={size} />;
  };
};
